
export class TwofishAlgorithm {
  static __static_initialized: boolean = false;
  static __static_initialize() { if (!TwofishAlgorithm.__static_initialized) { TwofishAlgorithm.__static_initialized = true; TwofishAlgorithm.__static_initializer_0(); } }

  constructor () {
  }

  static DEBUGLEVEL: number = 0;
  static RET16: number = 16;
  static P: number[][] = [[0]];
  static MDS: number[][] = [[0]];

  public static DEBUGLEVEL_$LI$(): number {
    TwofishAlgorithm.__static_initialize();
    return TwofishAlgorithm.DEBUGLEVEL;
  }

  public static P_$LI$(): number[][] {
    TwofishAlgorithm.__static_initialize();
    return TwofishAlgorithm.P;
  }

  public static MDS_$LI$(): number[][] {
    TwofishAlgorithm.__static_initialize();
    return TwofishAlgorithm.MDS;
  }

  static lfsr1(n: number): number {
    return n >> 1 ^ (((n & 1) !== 0) ? 180 : 0);
  }

  static lfsr2(n: number): number {
    return n >> 2 ^ (((n & 2) !== 0) ? 180 : 0) ^ (((n & 1) !== 0) ? 90 : 0);
  }

  static mxx(n: number): number {
    return n ^ TwofishAlgorithm.lfsr2(n);
  }

  static mxy(n: number): number {
    return n ^ TwofishAlgorithm.lfsr1(n) ^ TwofishAlgorithm.lfsr2(n);
  }

  public static makeKey(array: number[]): any {
    if (array == null) {
      throw Object.defineProperty(new Error("Empty key"), '__classes', { configurable: true, value: ['java.lang.Throwable', 'java.security.GeneralSecurityException', 'java.security.KeyException', 'java.security.InvalidKeyException', 'java.lang.Object', 'java.lang.Exception'] });
    }
    const length: number = array.length;
    if (length !== 8 && length !== 16 && length !== 24 && length !== 32) {
      throw Object.defineProperty(new Error("Incorrect key length"), '__classes', { configurable: true, value: ['java.lang.Throwable', 'java.security.GeneralSecurityException', 'java.security.KeyException', 'java.security.InvalidKeyException', 'java.lang.Object', 'java.lang.Exception'] });
    }
    const n: number = (length / 8 | 0);
    const n2: number = 40;
    const array2: number[] = [0, 0, 0, 0];
    const array3: number[] = [0, 0, 0, 0];
    const array4: number[] = [0, 0, 0, 0];
    for (let n3: number = 0, n4: number = 0, n5: number = n - 1; n4 < 4 && n3 < length; array2[n4] = ((array[n3++] & 255) | (array[n3++] & 255) << 8 | (array[n3++] & 255) << 16 | (array[n3++] & 255) << 24), array3[n4] = ((array[n3++] & 255) | (array[n3++] & 255) << 8 | (array[n3++] & 255) << 16 | (array[n3++] & 255) << 24), array4[n5] = TwofishAlgorithm.rsmdsEncode(array2[n4], array3[n4]), ++n4, --n5) {
      {
      };
    }
    const array5: number[] = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(n2);
    let i: number;
    for (let n6: number = i = 0; i < (n2 / 2 | 0); ++i, n6 += 33686018) {
      {
        const f32: number = TwofishAlgorithm.f32(n, n6, array2);
        const f33: number = TwofishAlgorithm.f32(n, n6 + 16843009, array3);
        const n7: number = f33 << 8 | f33 >>> 24;
        const n8: number = f32 + n7;
        array5[2 * i] = n8;
        const n9: number = n8 + n7;
        array5[2 * i + 1] = (n9 << 9 | n9 >>> 23);
      };
    }
    const n10: number = array4[0];
    const n11: number = array4[1];
    const array6: number[] = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(1024);
    for (let j: number = 0; j < 256; ++j) {
      {
        let n17: number;
        let n16: number;
        let n15: number;
        const n14: number = n15 = (n16 = (n17 = j));
        switch ((n & 3)) {
          case 1:
            array6[2 * j] = TwofishAlgorithm.MDS_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][n15] & 255) ^ TwofishAlgorithm.b0(n10)];
            array6[2 * j + 1] = TwofishAlgorithm.MDS_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][n14] & 255) ^ TwofishAlgorithm.b1(n10)];
            array6[512 + 2 * j] = TwofishAlgorithm.MDS_$LI$()[2][(TwofishAlgorithm.P_$LI$()[1][n16] & 255) ^ TwofishAlgorithm.b2(n10)];
            array6[512 + 2 * j + 1] = TwofishAlgorithm.MDS_$LI$()[3][(TwofishAlgorithm.P_$LI$()[1][n17] & 255) ^ TwofishAlgorithm.b3(n10)];
            break;
          case 2:
            array6[2 * j] = TwofishAlgorithm.MDS_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][n15] & 255) ^ TwofishAlgorithm.b0(n11)] & 255) ^ TwofishAlgorithm.b0(n10)];
            array6[2 * j + 1] = TwofishAlgorithm.MDS_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][(TwofishAlgorithm.P_$LI$()[1][n14] & 255) ^ TwofishAlgorithm.b1(n11)] & 255) ^ TwofishAlgorithm.b1(n10)];
            array6[512 + 2 * j] = TwofishAlgorithm.MDS_$LI$()[2][(TwofishAlgorithm.P_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][n16] & 255) ^ TwofishAlgorithm.b2(n11)] & 255) ^ TwofishAlgorithm.b2(n10)];
            array6[512 + 2 * j + 1] = TwofishAlgorithm.MDS_$LI$()[3][(TwofishAlgorithm.P_$LI$()[1][(TwofishAlgorithm.P_$LI$()[1][n17] & 255) ^ TwofishAlgorithm.b3(n11)] & 255) ^ TwofishAlgorithm.b3(n10)];
            break;
          default:
            break;
        }
      };
    }
    return [array6, array5];
  }

  public static blockEncrypt(array: number[], n: number, o: any): number[] {
    const array2: any[] = <any[]>o;
    const array3: number[] = <number[]>array2[0];
    const array4: number[] = <number[]>array2[1];
    const n2: number = (array[n++] & 255) | (array[n++] & 255) << 8 | (array[n++] & 255) << 16 | (array[n++] & 255) << 24;
    const n3: number = (array[n++] & 255) | (array[n++] & 255) << 8 | (array[n++] & 255) << 16 | (array[n++] & 255) << 24;
    const n4: number = (array[n++] & 255) | (array[n++] & 255) << 8 | (array[n++] & 255) << 16 | (array[n++] & 255) << 24;
    const n5: number = (array[n++] & 255) | (array[n++] & 255) << 8 | (array[n++] & 255) << 16 | (array[n] & 255) << 24;
    let n6: number = n2 ^ array4[0];
    let n7: number = n3 ^ array4[1];
    let n8: number = n4 ^ array4[2];
    let n9: number = n5 ^ array4[3];
    let n10: number = 8;
    for (let i: number = 0; i < 16; i += 2) {
      {
        const fe32: number = TwofishAlgorithm.fe32(array3, n6, 0);
        const fe33: number = TwofishAlgorithm.fe32(array3, n7, 3);
        const n11: number = n8 ^ fe32 + fe33 + array4[n10++];
        n8 = (n11 >>> 1 | n11 << 31);
        n9 = ((n9 << 1 | n9 >>> 31) ^ fe32 + 2 * fe33 + array4[n10++]);
        const fe34: number = TwofishAlgorithm.fe32(array3, n8, 0);
        const fe35: number = TwofishAlgorithm.fe32(array3, n9, 3);
        const n12: number = n6 ^ fe34 + fe35 + array4[n10++];
        n6 = (n12 >>> 1 | n12 << 31);
        n7 = ((n7 << 1 | n7 >>> 31) ^ fe34 + 2 * fe35 + array4[n10++]);
      };
    }
    const n13: number = n8 ^ array4[4];
    const n14: number = n9 ^ array4[5];
    const n15: number = n6 ^ array4[6];
    const n16: number = n7 ^ array4[7];
    return [(<number>n13 | 0), (<number>(n13 >>> 8) | 0), (<number>(n13 >>> 16) | 0), (<number>(n13 >>> 24) | 0), (<number>n14 | 0), (<number>(n14 >>> 8) | 0), (<number>(n14 >>> 16) | 0), (<number>(n14 >>> 24) | 0), (<number>n15 | 0), (<number>(n15 >>> 8) | 0), (<number>(n15 >>> 16) | 0), (<number>(n15 >>> 24) | 0), (<number>n16 | 0), (<number>(n16 >>> 8) | 0), (<number>(n16 >>> 16) | 0), (<number>(n16 >>> 24) | 0)];
  }

  static b0(n: number): number {
    return n & 255;
  }

  static b1(n: number): number {
    return n >>> 8 & 255;
  }

  static b2(n: number): number {
    return n >>> 16 & 255;
  }

  static b3(n: number): number {
    return n >>> 24 & 255;
  }

  static rsmdsEncode(n: number, n2: number): number {
    let rsrem: number = n2;
    for (let i: number = 0; i < 4; ++i) {
      {
        rsrem = TwofishAlgorithm.rsrem(rsrem);
      };
    }
    let rsrem2: number = rsrem ^ n;
    for (let j: number = 0; j < 4; ++j) {
      {
        rsrem2 = TwofishAlgorithm.rsrem(rsrem2);
      };
    }
    return rsrem2;
  }

  static rsrem(n: number): number {
    const n2: number = n >>> 24 & 255;
    const n3: number = (n2 << 1 ^ (((n2 & 128) !== 0) ? 333 : 0)) & 255;
    const n4: number = n2 >>> 1 ^ (((n2 & 1) !== 0) ? 166 : 0) ^ n3;
    return n << 8 ^ n4 << 24 ^ n3 << 16 ^ n4 << 8 ^ n2;
  }

  static f32(n: number, n2: number, array: number[]): number {
    const b0: number = TwofishAlgorithm.b0(n2);
    const b2: number = TwofishAlgorithm.b1(n2);
    const b3: number = TwofishAlgorithm.b2(n2);
    const b4: number = TwofishAlgorithm.b3(n2);
    const n3: number = array[0];
    const n4: number = array[1];
    let n7: number = 0;
    switch ((n & 3)) {
      case 1:
        n7 = (TwofishAlgorithm.MDS_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][b0] & 255) ^ TwofishAlgorithm.b0(n3)] ^ TwofishAlgorithm.MDS_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][b2] & 255) ^ TwofishAlgorithm.b1(n3)] ^ TwofishAlgorithm.MDS_$LI$()[2][(TwofishAlgorithm.P_$LI$()[1][b3] & 255) ^ TwofishAlgorithm.b2(n3)] ^ TwofishAlgorithm.MDS_$LI$()[3][(TwofishAlgorithm.P_$LI$()[1][b4] & 255) ^ TwofishAlgorithm.b3(n3)]);
        break;
      case 2:
        n7 = (TwofishAlgorithm.MDS_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][(TwofishAlgorithm.P_$LI$()[0][b0] & 255) ^ TwofishAlgorithm.b0(n4)] & 255) ^ TwofishAlgorithm.b0(n3)] ^ TwofishAlgorithm.MDS_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][(TwofishAlgorithm.P_$LI$()[1][b2] & 255) ^ TwofishAlgorithm.b1(n4)] & 255) ^ TwofishAlgorithm.b1(n3)] ^ TwofishAlgorithm.MDS_$LI$()[2][(TwofishAlgorithm.P_$LI$()[1][(TwofishAlgorithm.P_$LI$()[0][b3] & 255) ^ TwofishAlgorithm.b2(n4)] & 255) ^ TwofishAlgorithm.b2(n3)] ^ TwofishAlgorithm.MDS_$LI$()[3][(TwofishAlgorithm.P_$LI$()[1][(TwofishAlgorithm.P_$LI$()[1][b4] & 255) ^ TwofishAlgorithm.b3(n4)] & 255) ^ TwofishAlgorithm.b3(n3)]);
        break;
      default:
        break;
    }
    return n7;
  }
  static fe32(array: number[], n: number, n2: number): number {
    return array[2 * TwofishAlgorithm.bb(n, n2)] ^ array[2 * TwofishAlgorithm.bb(n, n2 + 1) + 1] ^ array[512 + 2 * TwofishAlgorithm.bb(n, n2 + 2)] ^ array[512 + 2 * TwofishAlgorithm.bb(n, n2 + 3) + 1];
  }
  static bb(n: number, n2: number): number {
    let n3: number = 0;
    switch ((n2 % 4)) {
      case 0:
        n3 = TwofishAlgorithm.b0(n);
        break;
      case 1:
        n3 = TwofishAlgorithm.b1(n);
        break;
      case 2:
        n3 = TwofishAlgorithm.b2(n);
        break;
      case 3:
        n3 = TwofishAlgorithm.b3(n);
        break;
      default:
        n3 = 0;
        break;
    }
    return n3;
  }

  public static blockSize(): number {
    return TwofishAlgorithm.RET16;
  }

  static __static_initializer_0() {
    TwofishAlgorithm.DEBUGLEVEL = 0;
    TwofishAlgorithm.P = [[-87, 103, -77, -24, 4, -3, -93, 118, -102, -110, -128, 120, -28, -35, -47, 56, 13, -58, 53, -104, 24, -9, -20, 108, 67, 117, 55, 38, -6, 19, -108, 72, -14, -48, -117, 48, -124, 84, -33, 35, 25, 91, 61, 89, -13, -82, -94, -126, 99, 1, -125, 46, -39, 81, -101, 124, -90, -21, -91, -66, 22, 12, -29, 97, -64, -116, 58, -11, 115, 44, 37, 11, -69, 78, -119, 107, 83, 106, -76, -15, -31, -26, -67, 69, -30, -12, -74, 102, -52, -107, 3, 86, -44, 28, 30, -41, -5, -61, -114, -75, -23, -49, -65, -70, -22, 119, 57, -81, 51, -55, 98, 113, -127, 121, 9, -83, 36, -51, -7, -40, -27, -59, -71, 77, 68, 8, -122, -25, -95, 29, -86, -19, 6, 112, -78, -46, 65, 123, -96, 17, 49, -62, 39, -112, 32, -10, 96, -1, -106, 92, -79, -85, -98, -100, 82, 27, 95, -109, 10, -17, -111, -123, 73, -18, 45, 79, -113, 59, 71, -121, 109, 70, -42, 62, 105, 100, 42, -50, -53, 47, -4, -105, 5, 122, -84, 127, -43, 26, 75, 14, -89, 90, 40, 20, 63, 41, -120, 60, 76, 2, -72, -38, -80, 23, 85, 31, -118, 125, 87, -57, -115, 116, -73, -60, -97, 114, 126, 21, 34, 18, 88, 7, -103, 52, 110, 80, -34, 104, 101, -68, -37, -8, -56, -88, 43, 64, -36, -2, 50, -92, -54, 16, 33, -16, -45, 93, 15, 0, 111, -99, 54, 66, 74, 94, -63, -32], [117, -13, -58, -12, -37, 123, -5, -56, 74, -45, -26, 107, 69, 125, -24, 75, -42, 50, -40, -3, 55, 113, -15, -31, 48, 15, -8, 27, -121, -6, 6, 63, 94, -70, -82, 91, -118, 0, -68, -99, 109, -63, -79, 14, -128, 93, -46, -43, -96, -124, 7, 20, -75, -112, 44, -93, -78, 115, 76, 84, -110, 116, 54, 81, 56, -80, -67, 90, -4, 96, 98, -106, 108, 66, -9, 16, 124, 40, 39, -116, 19, -107, -100, -57, 36, 70, 59, 112, -54, -29, -123, -53, 17, -48, -109, -72, -90, -125, 32, -1, -97, 119, -61, -52, 3, 111, 8, -65, 64, -25, 43, -30, 121, 12, -86, -126, 65, 58, -22, -71, -28, -102, -92, -105, 126, -38, 122, 23, 102, -108, -95, 29, 61, -16, -34, -77, 11, 114, -89, 28, -17, -47, 83, 62, -113, 51, 38, 95, -20, 118, 42, 73, -127, -120, -18, 33, -60, 26, -21, -39, -59, 57, -103, -51, -83, 49, -117, 1, 24, 35, -35, 31, 78, 45, -7, 72, 79, -14, 101, -114, 120, 92, 88, 25, -115, -27, -104, 87, 103, 127, 5, 100, -81, 99, -74, -2, -11, -73, 60, -91, -50, -23, 104, 68, -32, 77, 67, 105, 41, 46, -84, 21, 89, -88, 10, -98, 110, 71, -33, 52, 53, 106, -49, -36, 34, -55, -64, -101, -119, -44, -19, -85, 18, -94, 13, 82, -69, 2, 47, -87, -41, 97, 30, -76, 80, 4, -10, -62, 22, 37, -122, 86, 85, 9, -66, -111]];
    TwofishAlgorithm.MDS = <any>(function (dims) { let allocate = function (dims) { if (dims.length === 0) { return 0; } else { let array = []; for (let i = 0; i < dims[0]; i++) { array.push(allocate(dims.slice(1))); } return array; } }; return allocate(dims); })([4, 256]);
    const array: number[] = [0, 0];
    const array2: number[] = [0, 0];
    const array3: number[] = [0, 0];
    for (let i: number = 0; i < 256; ++i) {
      {
        const n: number = TwofishAlgorithm.P_$LI$()[0][i] & 255;
        array[0] = n;
        array2[0] = (TwofishAlgorithm.mxx(n) & 255);
        array3[0] = (TwofishAlgorithm.mxy(n) & 255);
        const n2: number = TwofishAlgorithm.P_$LI$()[1][i] & 255;
        array[1] = n2;
        array2[1] = (TwofishAlgorithm.mxx(n2) & 255);
        array3[1] = (TwofishAlgorithm.mxy(n2) & 255);
        const inicio: number = 0;
        TwofishAlgorithm.MDS_$LI$()[0][i] = (array[1] << inicio + 0 | array2[1] << inicio + 8 | array3[1] << inicio + 16 | array3[1] << inicio + 24);
        TwofishAlgorithm.MDS_$LI$()[1][i] = (array3[0] << inicio + 0 | array3[0] << inicio + 8 | array2[0] << inicio + 16 | array[0] << inicio + 24);
        TwofishAlgorithm.MDS_$LI$()[2][i] = (array2[1] << inicio + 0 | array3[1] << inicio + 8 | array[1] << inicio + 16 | array3[1] << inicio + 24);
        TwofishAlgorithm.MDS_$LI$()[3][i] = (array2[0] << inicio + 0 | array[0] << inicio + 8 | array3[0] << inicio + 16 | array2[0] << inicio + 24);
      };
    }
  }
}
